import React, { Component } from "react";
import style from "../../assets/css/modules/claims/claims-summary-mobile-row.css";
import ClaimsSummaryMobileCell from "./ClaimsSummaryMobileCell";
import { Link, withRouter } from "react-router-dom";
import Store from "../../content/Store";
import StatusPanel from "../shared/notices/StatusPanel";
import { connect } from "react-redux";
import { setClaimDetailsForClaim } from "../../actions/claims/claimsActions";
import Contentify from "../../content/Contentify";
import { API_ROOT } from "../../api-config";
import FileDownload from "../download/FileDownload";
import FileDownloadRetryLink from "../download/FileDownloadRetryLink";

export class ClaimsSummaryMobileRow extends Component {
  static content = Store.Claims;

  constructor(props) {
    super(props);
    this.state = {
      retryUrl: null,
      retryUrlData: null
    };
    this.claimDetailsOnClickHandler = this.claimDetailsOnClickHandler.bind(
      this
    );
  }

  async claimDetailsOnClickHandler() {
    if (!this.props.isFormat2) {
      await this.props.setClaimDetailsForClaim(
        this.props.claimSummary.ClaimNumber,
        this.props.claimSummary.MemberId,
        this.props.history
      );
    }
  }

  render() {
    const {
      isFormat2,
      claimSummary,
      content,
      isInternational,
      selectedMemberSecurityId,
      membershipNumber
    } = this.props;

    let label3Content;
    let label4Content;

    if (isFormat2) {
      if (typeof isInternational === "boolean" && !isInternational) {
        label3Content =
          content.AmountClaimedLabel + ": " + claimSummary.AmountClaimed;
        label4Content =
          content.AmountPaidLabel + ": " + claimSummary.AmountPaid;
      }
    } else {
      label3Content = claimSummary.DateNotified;
      label4Content = claimSummary.ClaimSubStatus;
    }

    return (
      <React.Fragment>
        <div
          className="col-5"
          onClick={this.claimDetailsOnClickHandler}
          onKeyPress={this.claimDetailsOnClickHandler}
        >
          <i
            className={
              `${this.props.isFormat2? "icon-claims-document " :"icon-functional-document " } ${style.claimSummaryMobileRowIcon}`
            }
          />
        </div>
        <div
          className={"col-7 pr-0 " + style.noPaddingLeft}
          onClick={this.claimDetailsOnClickHandler}
          onKeyPress={this.claimDetailsOnClickHandler}
        >
          <ClaimsSummaryMobileCell
            label1={claimSummary.ClaimNumber}
            label2={
              isFormat2
                ? claimSummary.AvailableDate
                : claimSummary.ClaimCondition
            }
            label3={label3Content}
            label4={this.props.claimSummary.ClaimCondition === "Optical Care" ||
              this.props.claimSummary.ClaimCondition === "Dental Care"  ||
              this.props.claimSummary.ClaimCondition === "Doctor@Hand" ||
              this.props.claimSummary.ClaimCondition === "Private GP Fees" ||
              this.props.claimSummary.ClaimCondition === "Health Assessment" ||
              this.props.claimSummary.ClaimCondition === "Vaccinations" ||
              this.props.claimSummary.ClaimCondition === "Accidental Death"
              ?null :label4Content}
            isFormat2={isFormat2}
            isMemberShortfall={claimSummary.IsMemberShortFall}
          />

          {this.props.isFormat2 ? (
            <React.Fragment>
              <div className={style.viewBenefitStatementLink}>
                <FileDownload
                  url={`${API_ROOT}/benefitstatement?benefitStatementId=${
                    claimSummary.BenefitStatementId
                  }&membershipNumber=${encodeURIComponent(
                    membershipNumber
                  )}&memberSecurityId=${selectedMemberSecurityId}`}
                  openInNewTab
                  setRetryFileUrl={(url, urlData) =>
                    this.setState({
                      retryUrl: url,
                      retryUrlData: urlData
                    })
                  }
                >
                  <i className="icon-document pr-2" />
                  {content.BenefitStatementPdfLinkLabel}
                </FileDownload>
              </div>
              {claimSummary.IsMemberShortFall ? (
                <div className="mt-2 pl-0 col-3">
                  <StatusPanel
                    text={content.PaymentNeededText}
                    statusColour="red"
                  />
                </div>
              ) : null}
            </React.Fragment>
          ) : (
            <div className={style.viewMobileClaimLink}>
              <Link
                to="#"
                onClick={this.claimDetailsOnClickHandler}
                aria-label={`View claim ${claimSummary.ClaimNumber}`}
              >
                View claim <span className="ml-2">➔</span>
              </Link>
            </div>
          )}
        </div>
        {this.state.retryUrl && this.state.retryUrlData ? (
          <div className="col-12">
            <FileDownloadRetryLink
              url={this.state.retryUrl}
              urlData={this.state.retryUrlData}
              fileName={`${content.BenefitStatementPdfLinkLabel} ${claimSummary.BenefitStatementId}.pdf`}
            />
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export const mapStateToClaimsSummaryMobileRow = ({
  claimsReducer,
  policyReducer
}) => {
  return {
    isFormat2:
      policyReducer.selectedPolicy && policyReducer.selectedPolicy.IsFormat2,
    isInternational:
      policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.IsInternational,
    selectedMemberSecurityId:
      claimsReducer.selectedPolicy &&
      claimsReducer.selectedPolicy.selectedClaimMember &&
      claimsReducer.selectedPolicy.selectedClaimMember.SecurityId
  };
};

export default withRouter(
  connect(mapStateToClaimsSummaryMobileRow, { setClaimDetailsForClaim })(
    Contentify(ClaimsSummaryMobileRow)
  )
);
